import { useState, useCallback } from 'react';
import { downloadFileByUrl } from '@moko/utils/src/fileHelper';

export const useFileDownload = () => {
  const [downloading, setDownloading] = useState(false);

  const download = useCallback(async (fileName: string, fileUrl: string) => {
    setDownloading(true);
    try {
      await downloadFileByUrl(fileName, fileUrl);
    } finally {
      setDownloading(false);
    }
  }, []);

  return { download, downloading };
};
